import { render, staticRenderFns } from "./reassign.vue?vue&type=template&id=9501beec&scoped=true"
import script from "./reassign.vue?vue&type=script&lang=js"
export * from "./reassign.vue?vue&type=script&lang=js"
import style0 from "./reassign.vue?vue&type=style&index=0&id=9501beec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9501beec",
  null
  
)

export default component.exports